import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import { messageInfo } from "@utils/message";
import liff from '@line/liff'
import router from '@router'
import lineGetProfileAndLogin from "@utils/line-get-profile-and-login";

export default [
  // ===
  // 登入
  // ===
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/Login/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLogoutPage: true
    }
  },
  // ===
  // 登出
  // ===
  {
    path: '/logout',
    name: 'logout',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await Promise.all([
            store.dispatch('auth/logOut'),
            store.dispatch('order/clearApplicablePrepaidOrderList')
          ]);

          if (routeTo.query.redirectFrom) {
            const { href } = router.resolve({
              name: routeTo.query.redirectFrom ? 'login' : 'home',
              query: {
                liffUserId: routeTo.query.liffUserId || undefined,
                redirectFrom: routeTo.query.redirectFrom || undefined,
              }
            });
            window.location = `${window.location.origin}${href}`
          } else {
            setTimeout(() => {
              messageInfo('已登出');
            }, 600);

            next({ name: 'home' })
          }
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isNullPage: true,
    },
  },
  // ===
  // LIFF
  // ===
  {
    path: '/liff/:liffId',
    name: 'liff',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          liff.init({
            liffId: routeTo.params.liffId
          })
            .then(() => {
              /* liff.sendMessages([{
               type: 'text',
               text: "test"
               }]); */
              // liff.isLoggedIn(): line 已經登入
              // liff.isLoggedIn()：line沒有登入
              // liff.isInClient()：true 代表在line之內
              if (liff.isLoggedIn() || (!liff.isLoggedIn() && liff.isInClient())) {
                lineGetProfileAndLogin({
                  liffId: routeTo.params.liffId,
                  redirectFrom: routeTo.query.redirectTo,
                  next
                })
              } else {
                liff.login({ redirectUri: window.location.href })
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isNullPage: true,
    },
  },

  // ===
  // LINE Notify
  // ===
  {
    path: '/line-notify-bind',
    name: 'line-notify-bind',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const code = routeTo.query.code
        const success = Boolean(routeTo.query.success)

        if (success) {
          try {
            await store.dispatch('auth/lineNotifyBind', { code })
            next({
              name: 'member-info',
              replace: true,
              query: {
                message: 'LINE Notify 綁定成功',
                messageType: 'success',
              }
            })
          } catch (error) {
            console.log(error)
            next({
              name: 'member-info',
              replace: true,
            })
          }
        } else {
          next({
            name: 'member-info',
            replace: true,
            query: {
              message: 'LINE Notify 綁定失敗',
              messageType: 'error',
            }
          })
        }
      },
      isLoginPage: true,
    },
  },
]
